import { UIEvent } from 'react';

export enum NOT_FOUND_CREDIT_CARD_FORM_CONST {
  TEST_ID = 'not-found-credit-card-form',
}

export type NotFoundCreditCardFormConfig = {
  onClickChangePayment: () => void;
  onClickToHome: (event: UIEvent<HTMLButtonElement>) => void;
};

export type NotFoundCreditCardFormProps = Omit<NotFoundCreditCardFormConfig, 'icon'>;
